import { useInvoicePdfCache } from "@/providers/invoice-pdf-cache";
import { useDeleteInvoice } from "@/queries/invoices/delete";
import { useCallback, useState } from "react";
import { Table } from "./table";
import { useReceivablesTable } from "./use-receivables-table";

export function ReceivablesTable({ tableName }: { tableName: string }) {
  const { fetchPdf } = useInvoicePdfCache();
  const deleteInvoices = useDeleteInvoice();

  const [selectedInvoiceId, setSelectedInvoiceId] = useState<string | null>(
    null,
  );

  const handleView = useCallback(
    async (invoiceId: string) => {
      setSelectedInvoiceId((prev) => (prev === invoiceId ? null : invoiceId));
    },
    [fetchPdf, setSelectedInvoiceId],
  );

  const handleDownload = useCallback(
    async (invoiceId: string, invoiceFileName: string) => {
      const pdf = await fetchPdf(invoiceId);
      const a = document.createElement("a");
      a.href = pdf.blob;
      a.download = invoiceFileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    [fetchPdf],
  );

  const handleDelete = useCallback(
    async (invoiceId: string) => {
      if (selectedInvoiceId === invoiceId) {
        setSelectedInvoiceId(null);
      }

      await deleteInvoices([invoiceId]);
    },
    [deleteInvoices],
  );

  const handleRowClick = useCallback(
    (event: React.MouseEvent, row: any, index: number) => {
      setSelectedInvoiceId((prev) =>
        prev === row.original.invoiceDetailsId
          ? null
          : row.original.invoiceDetailsId,
      );
    },
    [setSelectedInvoiceId],
  );

  const table = useReceivablesTable({
    tableName,
    onView: handleView,
    onDownload: handleDownload,
    onDelete: handleDelete,
  });

  return (
    <Table
      {...table}
      selectedInvoiceId={selectedInvoiceId}
      onRowClick={handleRowClick}
    />
  );
}
